'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLoader = createLoader;
exports.create = create;

var _legacyI18nInit = require('./legacyI18nInit');

function createLoader(_ref) {
  var context = _ref.context,
      source = _ref.source,
      mode = _ref.mode;

  if (!context) {
    throw new Error('invalid provider source');
  }
  var locales = Object.keys(context);

  function transformModule(mod) {
    return mod;
  }

  function loadContext(locale) {
    if (locales.indexOf(locale) < 0) {
      throw new Error('locale ' + locale + ' does not exist for ' + source);
    }
    return context[locale]();
  }

  function loadSync(locale) {
    if (mode !== 'sync') {
      throw new Error(source + ' is not sync');
    }
    return transformModule(loadContext(locale));
  }

  function loadLazy(locale) {
    if (mode !== 'lazy') {
      throw new Error(source + ' is not lazy');
    }
    return loadContext(locale).then(transformModule).catch(function (error) {
      return setTimeout(function () {
        throw error;
      }, 0);
    });
  }

  function getLocaleMatch(locale, isMoment) {
    var validLocale = (0, _legacyI18nInit.getValidLocale)(locale);
    var localeMatch = validLocale;

    if (isMoment) {
      // Avoid loading moment locales we do not support
      // This is to prevent moment from setting its locale to whatever locale was last imported
      if (!_legacyI18nInit.momentMappings[localeMatch]) {
        localeMatch = null;
      } else {
        localeMatch = _legacyI18nInit.momentMappings[localeMatch];
      }
      return localeMatch;
    }

    var langGroup = localeMatch.split('-')[0];
    if (locales.indexOf(localeMatch) < 0 && locales.indexOf(langGroup) >= 0) {
      localeMatch = langGroup;
    } else if (locales.indexOf(localeMatch) < 0) {
      localeMatch = null;
    }

    return localeMatch;
  }

  function load(allLocales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var loadLocalePromises = [];
    allLocales.forEach(function (locale) {
      var localeToLoad = getLocaleMatch(locale, options.isMoment);
      if (localeToLoad && mode === 'lazy') {
        loadLocalePromises.push(loadLazy(localeToLoad));
      } else if (localeToLoad) {
        loadLocalePromises.push(Promise.resolve(loadSync(localeToLoad)));
      }
    });

    var validPromise = window.Q ? window.Q.Promise : Promise;
    return validPromise.all(loadLocalePromises).catch(function (error) {
      return setTimeout(function () {
        throw error;
      }, 0);
    });
  }

  return { mode: mode, load: load, locales: locales, loadSync: loadSync, loadLazy: loadLazy };
}

function create() {
  var setLocale = void 0;

  var intl = {
    langRegistry: {},
    localePromise: new Promise(function (resolve) {
      return setLocale = resolve;
    }),

    register: function register(lang) {
      var loadOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.langRegistry[lang.source]) {
        return Promise.resolve();
      }
      this.langRegistry[lang.source] = lang;
      var provider = createLoader(lang);

      return this.localePromise.then(function (allLocales) {
        return provider.load(allLocales, loadOptions);
      }).then(function (messages) {
        return messages;
      }).catch(function (error) {
        return setTimeout(function () {
          throw error;
        }, 0);
      });
    }
  };

  intl.setLocale = setLocale;

  return intl;
}